import type {
  UpdateInvoiceAdditionalDetailsRequestPayload,
  UpdateInvoiceAdditionalDetailsResponse,
} from '@vy/api-definition';
import type { UseMutationOptions } from 'react-query';
import { useMutation, useQueryClient } from 'react-query';
import { getPrivateApi } from '../../services/api';
import { invalidateInvoicesQueries } from '../../utils/query-invalidation';

export function useUpdateInvoiceAdditionalDetails(
  options?: UseMutationOptions<
    UpdateInvoiceAdditionalDetailsResponse,
    unknown,
    UpdateInvoiceAdditionalDetailsRequestPayload
  >,
) {
  const queryClient = useQueryClient();

  return useMutation(
    (updateInvoiceAdditionalDetailsRequest) => {
      const api = getPrivateApi();

      return api.updateInvoiceAdditionalDetails({
        updateInvoiceAdditionalDetailsRequest,
      });
    },
    {
      onSuccess: async () => {
        await invalidateInvoicesQueries(queryClient);
      },
      ...options,
    },
  );
}
